import React from "react";
import AttachmentPreviewSkeleton from "./PreviewSkeleton";

type TextPreviewProps = {
  fileUrl?: string;
  fileName?: string;
  zoomLevel?: number;
};

const TextPreview: React.FC<TextPreviewProps> = ({
  fileUrl,
  zoomLevel = 100,
}) => {
  if (!fileUrl) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  return (
    <div className="flex h-full min-h-0 w-full items-center justify-center bg-gray-100 p-6">
      <p className="text-center text-base font-normal leading-6 text-secondary">
        This file cannot be previewed
      </p>
    </div>
  );
};

export default TextPreview;
